import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../.';
import { populateChildren } from './toolbox';

export const QOffersQuery = graphql`
  query QOffersQuery($filter: OffersFilterInput) {
    offers(filter: $filter) {
      id
      offerName
      offerId
      team
      isArchived
      dates {
        creation
        lastUpdate
      } 
      version {
        major
        minor
        status
        itemId
        itemRootId
        versionId
        comment
      }
    }
  }
`;

const QOffers = ({
  children,
  childDataProp,
  args
}) => (
  <Query
    query={QOffersQuery}
    args={args}
  >
    {populateChildren('offers')(children, childDataProp)}
  </Query>
);

QOffers.defaultProps = { args: { filter: null } };

export default QOffers;
